import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { DataGridFlexSales, useDataGridFlexSales, useDataGridSync } from '../../DataGridFlexSales';

import { reportFilterCountryCodeSelector, reportSalesJournalGcsSelector } from '../../../state';
import handlerFactory, { GcsDataGridContext } from './handlerFactory';
import { SalesJournalGcs } from '../../../types';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<SalesJournalGcs, GcsDataGridContext>();

  const { t } = useTranslation();
  const title = t('sales-journal.title');
  const country = useSelector(reportFilterCountryCodeSelector);
  const gcsResource = useSelector(reportSalesJournalGcsSelector);

  const { data, loading } = gcsResource;

  const gridContext = useMemo(
    () => ({
      t,
      country,
    }),
    [t, country]
  );

  useDataGridSync({
    handler,
    data,
    context: gridContext,
    title,
    loading,
  });

  return null;
};

const GcsDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default GcsDataGrid;
